<script lang="ts" setup>
const { t } = useLang()
const event = useRequestEvent()
const handleError = () => clearError({ redirect: '/' })
setResponseStatus(event, 404)
const { isTarpininke } = useTheme()
const mpLock = useMarketplaceLock()

definePageMeta({
  layout: false,
})
</script>

<template>
  <div>
    <NuxtLayout name="simple-layout">
      <div class="flex flex-col lg:p-4 alt:p-0 h-full flex-1">
        <main class="max-w-xlg w-full mx-auto alt:max-w-full alt:bg-brand-bgLight alt:p-4 flex-1">
          <div class="alt:max-w-xlg alt:mx-auto">
            <div
              class="flex-1 text-center flex flex-col items-center mt-8 lg:mt-[5.625rem] alt:text-left alt:items-start alt:lg:mb-[5.625rem]">
              <h3 v-text="t('error.page-not-found')" />
              <span
                v-if="isTarpininke ? mpLock.isUnlocked.value : true"
                class="p-4 pb-[3rem]"
                v-text="t('error.dont-leave-popular-items')" />
              <Button class="max-w-max" @click="handleError">
                {{ t('error.return-to-homepage') }}
              </Button>
            </div>
          </div>
        </main>
        <div v-if="isTarpininke ? mpLock.isUnlocked.value : true" class="py-[5rem] text-left alt:bg-brand-bgLight">
          <PopularProducts :title="t('category.most-popular-products')" sort="BestSellers" />
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>
